import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import APIS from "@service/api";
import { getUser } from "@utils";

export const riskApi = createApi({
	reducerPath: "riskApi",
	refetchOnFocus: true,
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	baseQuery: fetchBaseQuery({
		baseUrl: APIS["risk-api"],
		prepareHeaders: (headers) => {
			const user = getUser();

			if (user?.token) {
				headers.set("Authorization", `Bearer=${user.token}`);
			}

			return headers;
		},
	}),
	endpoints: (builder) => ({
		getRiskRadarCheck: builder.query({
			query: (params) => ({
				url: "radarcheck",
				method: "GET",
				params,
			}),
			providesTags: ["RiskRadarCheck"],
		}),
	}),
});

export const { useGetRiskRadarCheckQuery } = riskApi;
